import SJNoData from '@/components/SJNoData'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { InfiniteScroll, PullToRefresh } from 'antd-mobile'
import { getRecords } from '@/services/history'
import { Records, Session } from '@/services/types/history'
import GameItem from '../index/components/GameInfo/GameItem'

type State = {
  playerId: string
  gameSel: string
}
const ChessList = () => {
  document.title = '对弈记录'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: State }
  const { playerId, gameSel } = state

  const [records, setRecords] = useState<Session[]>([])
  const [hasMore, setHasMore] = useState(true)
  const pageRef = useRef(1)
  const sizeRef = useRef(5)

  useEffect(() => {
    fetchGameRecord()
  }, [])

  const fetchGameRecord = async (page = 1, size = sizeRef.current) => {
    console.log('fetchGameRecord', playerId, gameSel)
    if (playerId && Number(gameSel) > 0) {
      try {
        const res = (await getRecords({
          user_id: playerId,
          game_mode: Number(gameSel),
          page,
          size,
        })) as unknown as Records
        if (res.page === 1) {
          setRecords(res.sessions)
        } else {
          setRecords(records.concat(res.sessions))
        }
        pageRef.current = res.page
        setHasMore(res.page < res.page_total)
      } catch (error) {}
    }
  }

  const fetchMore = async () => {
    hasMore && (await fetchGameRecord(pageRef.current + 1))
  }

  const goHistroy = (item: Session) => {
    navigate(`/chess/history?sessionId=${item.session_id}&playerId=${playerId}`)
  }

  return (
    <div className="chess-list">
      <PullToRefresh onRefresh={fetchGameRecord}>
        <div className="main">
          {records.map((item) => (
            <GameItem key={item.session_id} game={item} onClick={() => goHistroy(item)}></GameItem>
          ))}
          {records.length ? (
            <InfiniteScroll loadMore={fetchMore} hasMore={hasMore}></InfiniteScroll>
          ) : (
            <SJNoData text="暂无数据，快去和机器人互动吧" onClick={() => goHistroy} />
          )}
        </div>
      </PullToRefresh>
    </div>
  )
}

export default ChessList
